import { assistantPolicy } from './assistant.js';
import { auditPolicy } from './audit.js';
import { billingPolicy, checkoutPolicy, portalPolicy, subscriptionPolicy, webhookPolicy, } from './billing.js';
import { contactPolicy } from './contact.js';
import { consentPolicy, devicePolicy, noticePolicy, notificationPolicy, preferencePolicy, } from './engagement.js';
import { invitationPolicy, mePolicy, membershipPolicy } from './identity.js';
import { deletionPolicy, exportPolicy } from './tenant-data.js';
import { adminPolicy, announcementPolicy, catalogPolicy, cellPolicy, productPolicy, directoryPolicy, entitlementPolicy, menuPolicy, meteringPolicy, packagePolicy, signupPolicy, tenantPolicy, tierPolicy, workspacePolicy, } from './platform.js';
/** The shipped policy set: one entry per resource kind. */
export const defaultPolicies = {
    tenant: tenantPolicy,
    package: packagePolicy,
    tier: tierPolicy,
    workspace: workspacePolicy,
    entitlement: entitlementPolicy,
    catalog: catalogPolicy,
    signup: signupPolicy,
    directory: directoryPolicy,
    cell: cellPolicy,
    product: productPolicy,
    admin: adminPolicy,
    menu: menuPolicy,
    metering: meteringPolicy,
    me: mePolicy,
    membership: membershipPolicy,
    invitation: invitationPolicy,
    contact: contactPolicy,
    billing: billingPolicy,
    checkout: checkoutPolicy,
    portal: portalPolicy,
    subscription: subscriptionPolicy,
    webhook: webhookPolicy,
    notification: notificationPolicy,
    consent: consentPolicy,
    device: devicePolicy,
    preference: preferencePolicy,
    audit: auditPolicy,
    assistant: assistantPolicy,
    export: exportPolicy,
    deletion: deletionPolicy,
    notice: noticePolicy,
    announcement: announcementPolicy,
};
export { adminPolicy, announcementPolicy, assistantPolicy, auditPolicy, billingPolicy, catalogPolicy, cellPolicy, productPolicy, checkoutPolicy, consentPolicy, contactPolicy, deletionPolicy, devicePolicy, directoryPolicy, entitlementPolicy, exportPolicy, invitationPolicy, mePolicy, membershipPolicy, menuPolicy, meteringPolicy, noticePolicy, notificationPolicy, packagePolicy, portalPolicy, preferencePolicy, signupPolicy, subscriptionPolicy, tenantPolicy, tierPolicy, webhookPolicy, workspacePolicy, };
//# sourceMappingURL=index.js.map